module.exports = __webpack_public_path__ + "img/aoyou.b828bc81.jpg";